// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import reportVersionEntity from './entities/report-version.json';
import reportVersionMenu from '../pages/report-version/menu.json';
import reportVersionFullForm from '../pages/report-version/forms/full.json';
import reportVersionContextForm from '../pages/report-version/forms/context.json';
import reportVersionMiniForm from '../pages/report-version/forms/mini.json';
import reportVersionLookupForm from '../pages/report-version/forms/lookup.json';
import reportVersionTableView from '../pages/report-version/views/table.json';
import reportVersionCardsView from '../pages/report-version/views/cards.json';
import reportVersionCalendarView from '../pages/report-version/views/calendar.json';
import reportVersionDashboardView from '../pages/report-version/views/dashboard.json';

/** Тип запису «Версія звіту» зі сторінками пакета: меню, форми та подання з pages/report-version/. */
export const reportVersionDefinition: IRecordTypeDefinition = {
  ...reportVersionEntity,
  views: assembleViewSet({
      table: reportVersionTableView,
      cards: reportVersionCardsView,
      calendar: reportVersionCalendarView,
      dashboard: reportVersionDashboardView,
  }),
  form: reportVersionFullForm,
  forms: { full: reportVersionFullForm, context: reportVersionContextForm, mini: reportVersionMiniForm, lookup: reportVersionLookupForm },
  menu: reportVersionMenu,
} as IRecordTypeDefinition;
